module.exports = __webpack_public_path__ + "assets/img/home-scdx-light.017c3ea9.png";